var exports = {
  "X": "Scroller.module__scroller___Z0tCUD",
  "x": "Scroller.module__scrollerTextarea___Z0tCUD",
};

module.exports = exports;
